import {http} from "Services/Http/HttpClient";

export const addInscriptionObservation = async(
    inscriptionId: string,
    observation: string,
    sendMailToTutor: boolean = false
) => {
    return await http.post(`inscriptions/${inscriptionId}/observation`, {
        observation: observation,
        sendMailToTutor: sendMailToTutor
    })
}

export const updateInscription = async(inscriptionId:string, body: any) => {
    return await http.patch(`inscriptions/${inscriptionId}/admin`, {
        status: body.status,
        inscriptionOrderDiscountType: body.inscriptionOrderDiscountType,
        inscriptionOrderActivitiesToDelete: body.inscriptionOrderActivitiesToDelete,
        socialWorker: body.socialWorker ?? null,
        rejectedReason: body.rejectedReason ?? null
    })
}

export const markPaymentReportAsCharged = async(body: {
    month: number,
    year: number,
    centerId?: string,
    centerIds?: string[],
    status?: string,
    childId?: string,
    childIds?: string[]
}) => {
    return await http.post(`inscriptions/payment-report/admin/mark-as-charged`, body)
}
